import React from "react";
import TextInput from "./";
import AuthService from "../../../../services/AuthService";
import { fetchJSON } from "../../../../helpers/Helpers";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import {COUNTRY_OPTIONS} from "../../../../helpers/Constants";
import SelectInput from "../SelectInput";

export default class SalespersonIdTextInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        if (this.props.initialId) {
            this.load();
        }
    }

    onBlur = () => {
        const { teamMember } = this.state;

        const { value } = this.props;

        if (typeof value === 'undefined' || value === '') {
            this.setState({
                teamMember: null,
                loading: false,
            });
            return;
        }

        if (!teamMember || `${teamMember.TM_ID}` !== value) {
            this.setState(
                {
                    loading: true,
                    teamMember: null
                },
                this.load
            );
        }
    };

    load = () => {
        const url = `/api/team?id=${this.props.value || ""}`;
        const options = {
            headers: {
                "Cache-Control": "no-store",
                Authorization: "Bearer " + AuthService.getToken()
            }
        };

        fetchJSON(url, options)
            .then(result => {
                if (result.success) {
                    this.setState(
                        {
                            loading: false,
                            error: null,
                            teamMember: result.json.team_member
                        }
                    );
                } else {
                    this.setState({
                        loading: false,
                        error:
                            result.json.error ||
                            "Requires valid salesperson ID."
                    });
                }
            })
            .catch(result => {
                const defaultErr =
                    "Unable to verify salesperson ID at this time.";
                this.setState({
                    loading: false,
                    error:
                        result.json && result.json.error
                            ? result.json.error
                            : defaultErr
                });
            });
    };

    handleInput = event => {
        event.persist();
        this.props.onChange(event);
        this.setState({
            error: null,
            teamMember: null,
        });
    };

    render() {
        let teamComponent;
        const country_style ={marginTop:"65px"};
        if (!this.state.loading && this.state.teamMember) {
            teamComponent = (
                <div className="text--center alert alert--success padding--20--left padding--20--right">
                    {this.state.teamMember.TM_NAME}
                </div>
            );
        }

        return (
            <div className="col">
                <label htmlFor="salespersonId" className="sub-title text--grey">
                    {this.props.label}
                </label>
                {this.props.tooltip}
                <div className="col-2 gutter--10">
                    <div className="col">
                        <input
                            type={"text"}
                            name={this.props.name}
                            value={this.props.value}
                            className='required'
                            onChange={this.handleInput}
                            required={this.props.required}
                            onBlur={this.onBlur}
                            id={this.props.id}
                        />
                    </div>
                    <div className="col">{teamComponent}</div>
                </div>
                
                {this.props.error && (
                    <span className="error text--red">{this.props.error}</span>
                )}
                {!this.props.error && this.state.error && (
                    <span className="error text--red">{this.state.error}</span>
                )}
                {!this.props.error && this.props.warning && (
                    <span className="error text--warning">
                        {this.props.warning}
                    </span>
                )}

                
            </div>
        );
    }
}
